(() => {
  'use strict';
  if (window.scpWishlistPageInstalled) return;
  window.scpWishlistPageInstalled = true;
  const instances = new WeakSet();
  const readSaved = () => {
    const state=window.SCPWishlistStore.read();
    return {...state,ids:[...new Set(state.entries.map(entry=>entry.pid))]};
  };
  const removeSaved = key => window.SCPWishlistStore.remove(key);
  const restoreSaved = change => window.SCPWishlistStore.undo(change);
  const node = (tag,className,text) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  };
  const rootURL = () => {
    const root = new URL(window.Shopify?.routes?.root || '/',location.origin);
    return root.origin === location.origin ? root : new URL('/',location.origin);
  };
  const imageURL = source => {
    if (typeof source !== 'string' || !source) return null;
    try {
      const url = new URL(source,location.origin);
      if (url.protocol !== 'https:' && url.origin !== location.origin) return null;
      if (url.hostname === 'cdn.shopify.com' || (url.origin === location.origin && url.pathname.startsWith('/cdn/shop/'))) url.searchParams.set('width','600');
      return url.href;
    } catch { return null; }
  };
  const initialise = root => {
    if (instances.has(root)) return;
    instances.add(root);
    const find = name => root.querySelector('[data-wishlist-'+name+']');
    const grid = find('grid'), empty = find('empty'), error = find('error'), count = find('total');
    const copy = JSON.parse(find('copy').textContent);
    const cache = new Map();
    let generation = 0, undo = null, lastSignature = null, ownUpdate = false;
    const titleFor = key => {const entry=readSaved().entries.find(item=>item.key===key);const product=cache.get(entry?.pid)?.product;return (product?.title||copy.missing)+(entry?.title?' — '+entry.title:'');};
    const announce = text => { find('announcement').textContent = text; };
    const showError = key => { find('error-text').textContent = copy[key]; error.hidden = false; };
    const countText = total => total === 0 ? copy.zero : total === 1 ? copy.one : copy.many.replace('{count}',String(total));
    const money = cents => {
      const currency = window.Shopify?.currency?.active || root.dataset.currency || 'GBP';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB',{style:'currency',currency}).format(Number(cents)/100); }
      catch { return new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(Number(cents)/100); }
    };
    const buttonFor = (id,title) => {
      const button = node('button','scp-wishlist__remove');
      button.type = 'button'; button.dataset.wishlistRemove = id;
      button.setAttribute('aria-label',copy.remove.replace('{title}',title)); button.title = button.getAttribute('aria-label');
      const svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
      svg.setAttribute('viewBox','0 0 24 24'); svg.setAttribute('aria-hidden','true');
      const path = document.createElementNS('http://www.w3.org/2000/svg','path');
      path.setAttribute('d','M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 10v7M14 10v7');
      svg.append(path); button.append(svg); return button;
    };
    const renderCard = (entry,product,index) => {
      const id=entry.key;
      const variant=entry.vid?product?.variants?.find(item=>String(item.id)===entry.vid&&Number.isFinite(Number(item.price))):null;
      const missingVariant=!!entry.vid&&!variant;
      const card = node('article','scp-wishlist__card'+(product?'':' scp-wishlist__card--missing'));
      card.setAttribute('role','listitem'); card.dataset.savedId = id;
      const body = node('div','scp-wishlist__body');
      if (!product) {
        card.append(node('div','scp-wishlist__placeholder',copy.image));
        body.append(node('h2','scp-wishlist__title',copy.missing),node('p','scp-wishlist__missing-id',copy.reference.replace('{id}',entry.vid?entry.pid+' / '+entry.vid:entry.pid)),node('p','scp-wishlist__availability',copy.missing_help));
      } else {
        const productURL=new URL('products/'+encodeURIComponent(product.handle),rootURL());
        if(variant)productURL.searchParams.set('variant',entry.vid);
        const url=productURL.href;
        const imageLink = node('a','scp-wishlist__image-link'); imageLink.href = url; imageLink.tabIndex = -1; imageLink.setAttribute('aria-hidden','true');
        const image = imageURL(variant?.featured_image?.src || variant?.featured_image?.url || (typeof variant?.featured_image==='string'?variant.featured_image:null) || product.featured_image || product.images?.[0]);
        if (image) {
          const img = node('img','scp-wishlist__image'); img.src = image; img.alt = ''; img.width = 600; img.height = 480;
          img.loading = index < 4 ? 'eager' : 'lazy'; img.decoding = 'async';
          img.addEventListener('error',()=>imageLink.replaceChildren(node('div','scp-wishlist__placeholder',copy.image)),{once:true});
          imageLink.append(img);
        } else imageLink.append(node('div','scp-wishlist__placeholder',copy.image));
        card.append(imageLink);
        if (product.vendor) body.append(node('div','scp-wishlist__vendor',product.vendor));
        const heading = node('h2','scp-wishlist__title'), link = node('a','',product.title); link.href = url; heading.append(link); body.append(heading);
        if(entry.vid){
          const options=node('div','scp-wishlist__options');
          if(variant&&variant.title!=='Default Title'){
            const values=variant.options||[variant.option1,variant.option2,variant.option3].filter(Boolean);
            values.forEach((value,index)=>{const name=product.options?.[index]?.name||product.options?.[index]||'';options.append(node('span','scp-wishlist__option',(typeof name==='string'&&name?name+': ':'')+value));});
          }else if(missingVariant)options.append(node('span','scp-wishlist__option',entry.title||copy.saved_option));
          body.append(options);
        }else if(product.variants?.length>1)body.append(node('span','scp-wishlist__option scp-wishlist__option--unspecified',copy.unspecified));
        if(!missingVariant){
          const price=node('p','scp-wishlist__price');
          if(!variant&&Number(product.price_max)>Number(product.price_min??product.price))price.append(node('span','scp-wishlist__from',copy.from));
          price.append(document.createTextNode(money(variant?variant.price:(product.price_min??product.price))));body.append(price);
        }
        const available=variant?variant.available:product.available;
        body.append(node('p','scp-wishlist__availability'+(!available||missingVariant?' scp-wishlist__availability--unavailable':''),missingVariant?copy.variant_missing:available?copy.delivery:copy.unavailable));
        const action=node('a','scp-wishlist__action',missingVariant||(!entry.vid&&product.variants?.length>1)?copy.choose_options:variant?copy.view_option:copy.view);action.href=url;body.append(action);
      }
      card.append(body,buttonFor(id,product?(product.title+((variant?.title||entry.title)&&variant?.title!=='Default Title'?' — '+(variant?.title||entry.title):'')):copy.reference.replace('{id}',entry.vid?entry.pid+' / '+entry.vid:entry.pid))); return card;
    };
    const loadProduct = async (id,handle,force) => {
      if (typeof handle !== 'string' || !/^[a-zA-Z0-9][a-zA-Z0-9-]*$/.test(handle)) return null;
      const saved = cache.get(id);
      if (!force && saved?.handle === handle && Date.now()-saved.time<30000) return saved.product;
      const controller = new AbortController(), timeout = setTimeout(()=>controller.abort(),8000);
      try {
        const response = await fetch(new URL('products/'+encodeURIComponent(handle)+'.js',rootURL()),{credentials:'same-origin',signal:controller.signal});
        if (!response.ok) return null;
        const product = await response.json();
        if (!product || String(product.id)!==id || typeof product.title!=='string' || !/^[a-zA-Z0-9][a-zA-Z0-9-]*$/.test(product.handle) || !Number.isFinite(Number(product.price))) return null;
        cache.set(id,{product,handle,time:Date.now()}); return product;
      } catch { return null; } finally { clearTimeout(timeout); }
    };
    const refresh = async (force=false) => {
      if (!root.isConnected) return;
      let state;
      try { state = readSaved(); } catch { showError('storage'); find('loading').hidden=true;find('skeleton').hidden=true;empty.hidden=true;grid.setAttribute('aria-busy','false');return; }
      const signature = JSON.stringify([state.items,state.handles,state.meta]);
      if (!force && signature===lastSignature) return;
      const run = ++generation;
      lastSignature = signature;
      error.hidden=true; count.textContent=countText(state.entries.length); empty.hidden=state.entries.length!==0;
      if (!state.entries.length) {grid.replaceChildren();find('loading').hidden=true;find('skeleton').hidden=true;grid.setAttribute('aria-busy','false');return;}
      grid.setAttribute('aria-busy','true');
      const products = new Array(state.ids.length); let cursor = 0;
      await Promise.all(Array.from({length:Math.min(4,state.ids.length)},async()=>{while(cursor<state.ids.length){const index=cursor++;const id=state.ids[index];products[index]=await loadProduct(id,state.handles[id],force);}}));
      if (run!==generation || !root.isConnected) return;
      try {const latest=readSaved();if(JSON.stringify([latest.items,latest.handles,latest.meta])!==signature){lastSignature=null;refresh();return;}}catch{showError('storage');return;}
      const fragment=document.createDocumentFragment();
      const byProduct=new Map(state.ids.map((id,index)=>[id,products[index]]));
      state.entries.forEach((entry,index)=>fragment.append(renderCard(entry,byProduct.get(entry.pid),index)));
      const focused = grid.contains(document.activeElement) ? document.activeElement.closest('[data-saved-id]')?.dataset.savedId : null;
      grid.replaceChildren(fragment);grid.setAttribute('aria-busy','false');find('loading').hidden=true;find('skeleton').hidden=true;
      if (focused) [...grid.querySelectorAll('[data-wishlist-remove]')].find(button=>button.dataset.wishlistRemove===focused)?.focus();
      if (products.some(product=>!product)) showError('partial');
    };
    root.addEventListener('click',async event=>{
      const button=event.target.closest('button');if(!button)return;
      if(button.hasAttribute('data-wishlist-retry')){lastSignature=null;await refresh(true);return;}
      if(button.hasAttribute('data-wishlist-undo-button')&&undo){
        ownUpdate=true;
        try{const change=undo;await restoreSaved(change);undo=null;find('undo').hidden=true;announce(copy.restored);await refresh();[...grid.querySelectorAll('[data-wishlist-remove]')].find(el=>el.dataset.wishlistRemove===change.removed[0]?.key)?.focus();}
        catch{showError('save_error');}finally{ownUpdate=false;}return;
      }
      const id=button.dataset.wishlistRemove;if(!id||ownUpdate)return;
      const buttons=[...grid.querySelectorAll('[data-wishlist-remove]')],index=buttons.indexOf(button),title=titleFor(id);
      ownUpdate=true;
      try{
        const removed=await removeSaved(id);if(!removed.removed.length)return;undo=removed;
        find('undo-text').textContent=copy.removed.replace('{title}',title);find('undo').hidden=false;announce(copy.removed.replace('{title}',title));
        await refresh();const next=[...grid.querySelectorAll('[data-wishlist-remove]')];(next[Math.min(index,next.length-1)]||find('undo-button')).focus();
      }catch{showError('save_error');}finally{ownUpdate=false;}
    });
    const onChange=()=>{if(!ownUpdate && root.isConnected)refresh();};
    window.addEventListener('wishlist-updated',onChange);
    window.addEventListener('storage',event=>{if(['wishlist','wishlist_handles','wishlist_variant_state_v1',null].includes(event.key))onChange();});
    window.addEventListener('pageshow',onChange);
    window.addEventListener('focus',()=>refresh(true));
    refresh();
    [500,1500,4000,8000].forEach(delay=>setTimeout(onChange,delay));
  };
  const boot = root => {if(window.SCPWishlistStore)root.querySelectorAll('[data-scp-wishlist]').forEach(initialise);};
  window.addEventListener('scp:wishlist-ready',()=>boot(document));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(document),{once:true});else boot(document);
  document.addEventListener('shopify:section:load',event=>boot(event.target));
})();
